/**
 * Reports View
 */
export default () => ({
  path: "/alerts",
  title: "Alertas",

  onEnter: (nextState, transition) => {
    if (nextState.location.pathname === "/") {
      transition({ pathname: "/alerts/detail" });
    }
  },

  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const AlertsLayout = require("./components/AlertsLayout").default;
        const AlertStatusBar = require("../../components/AlertsStatusBar").default;
        const ToolbarFilters = require('../../components/ToolbarFilters').default
        cb(null, {
          content: AlertsLayout,
          statusBar: AlertStatusBar,
          toolbarFilters: ToolbarFilters
        });
      },
      "alerts"
    );
  },

  getChildRoutes(location, callback) {
    callback(null, [
      {
        path: "stats",
        title: "Alertas > Estadisticas",
        getComponent(nextState, cb) {
          require.ensure(
            [],
            require => {
              const AlertsStatsContainer = require("./containers/AlertsStatsContainer")
                .default;
              cb(null, AlertsStatsContainer);
            },
            "alerts-stats"
          );
        }
      },
      {
        path: "detail(/:id)",
        title: "Alertas > Detalle",
        getComponent(nextState, cb) {
          require.ensure(
            [],
            require => {
              const AlertsDetailContainer = require("./containers/AlertsDetailContainer")
                .default;
              cb(null, AlertsDetailContainer);
            },
            "alerts-detail"
          );
        }
      }
    ]);
  }
});



// WEBPACK FOOTER //
// ./src/routes/Alerts/index.js